// screens/PlansScreen.js
// BuzzInApp — Planes de suscripción para comercios
// Esta pantalla es informativa por ahora (sin integración de pago activa).
// La integración real de Mercado Pago / Stripe se hace en Fase 2.
//
// Props:
//   authHook    retorno de useAuth
//   onBack      () => void

import React from "react";
import { detectRegion, getPlansByRegion } from "../config/payments";
import useTranslation from "../i18n/useTranslation";
import "./PlansScreen.css";

const IconCheck = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path d="M5 13l4 4L19 7" stroke="var(--success)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconBack = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PlansScreen = ({ authHook, onBack }) => {
  const { t } = useTranslation();

  const region = detectRegion();
  const plans  = getPlansByRegion(region);

  const formatPrice = (price, currency) => {
    if (price === 0) return t("plans.free");
    if (currency === "USD") return `$${price}`;
    if (currency === "INR") return `₹${price}`;
    return `$${price}`;
  };

  return (
    <div className="plans-screen">
      <header className="plans-screen__header">
        <button className="plans-screen__back" onClick={onBack} aria-label={t("app.back")}>
          <IconBack />
        </button>
        <div>
          <h1 className="plans-screen__title">{t("plans.title")}</h1>
          <p className="plans-screen__subtitle">{t("plans.subtitle")}</p>
        </div>
      </header>

      <div className="plans-screen__body">
        {/* Banner early partner */}
        <div className="plans-screen__banner">
          🎉 {t("plans.earlyPartner")}
        </div>

        {/* Cards de planes */}
        {plans.map((plan) => (
          <div
            key={plan.id}
            className={`plans-screen__card ${plan.highlighted ? "plans-screen__card--highlighted" : ""}`}
          >
            {plan.highlighted && (
              <span className="plans-screen__popular">{t("plans.mostPopular")}</span>
            )}

            <div className="plans-screen__plan-header">
              <span className="plans-screen__plan-name">{plan.name}</span>
              <div className="plans-screen__plan-price">
                <span className="plans-screen__price-amount">
                  {formatPrice(plan.priceMonthly, plan.currency)}
                </span>
                {plan.priceMonthly > 0 && (
                  <span className="plans-screen__price-period">
                    {t("plans.perMonth")}
                  </span>
                )}
              </div>
            </div>

            <ul className="plans-screen__features">
              {plan.features.map((feature, i) => (
                <li key={i} className="plans-screen__feature">
                  <IconCheck />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <p className="plans-screen__best-for">{plan.bestFor}</p>

            <button
              className={`plans-screen__btn ${plan.highlighted ? "plans-screen__btn--primary" : "plans-screen__btn--secondary"}`}
              onClick={() => {
                // Fase 2: abrir flujo de pago
                alert(`Próximamente: integración de pago para el plan ${plan.name}`);
              }}
            >
              {plan.priceMonthly === 0 ? "Empezar gratis" : t("plans.upgrade")}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlansScreen;
